import React from "react";
import ModeCommentIcon from "@mui/icons-material/ModeComment";
import StyledTooltip from "../../../StyledTooltip/StyledTooltip";
import { nullCheck } from "../../../../utils/dataHelpers";

export default function OfferCommentCell(cell) {
  const comments = nullCheck(cell, "", "row", "original", "comments");

  return (
    <StyledTooltip title={comments}>
      <ModeCommentIcon sx={{ color: comments ? "primary.60" : "primary.20", size: "10px" }} />
    </StyledTooltip>
  );
}